import React from 'react';

import SimpleMessagePage from 'components/SimpleMessagePage';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

const UnifiedIssuanceErrorAlert: React.FC = () => {
  const tMd = useMarkdownTranslate();
  return (
    <SimpleMessagePage
      headerTitle={'unified.issuanceError.header.title'}
      message={tMd('unified.issuanceError.header.message')}
    ></SimpleMessagePage>
  );
};

export default UnifiedIssuanceErrorAlert;
